import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function PaymentsForWorkBusinessInfoContent() {
  return (
    <>
      <InfoPanelTitle>
        What do you need to know about payments for work on your business?
      </InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          You must report certain payments you make to contractors or service
          providers on Form 1099.
        </p>
        <p>
          You generally must file Form 1099-NEC if, during the year, you paid{' '}
          <strong>$600 or more</strong> to a person or business for services
          such as:
        </p>
        <ul>
          <li>Contractor work or professional services</li>
          <li>Rent payments (if applicable)</li>
          <li>Any other service performed for your business</li>
        </ul>
        <p>This does not apply to:</p>
        <ul>
          <li>Payments to corporations (with some exceptions)</li>
          <li>
            Payments made by credit card (the processor handles reporting)
          </li>
          <li>Personal expenses not related to the business</li>
        </ul>
        <p>
          If you answer Yes, you may need to indicate whether you already filed
          the required forms or need help determining if filing is necessary.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Instructions for Forms 1099-MISC and 1099-NEC (04/2025)',
              url: 'https://www.irs.gov/instructions/i1099mec',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
